import { render, staticRenderFns } from "./click.vue?vue&type=template&id=354df84f"
import script from "./click.vue?vue&type=script&lang=js"
export * from "./click.vue?vue&type=script&lang=js"
import style0 from "./click.vue?vue&type=style&index=0&id=354df84f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports